import { httpServiceClient } from '@/infra/http'
import { NamingStrategy } from '@/infra/http/http-service-client/http-service-client-types'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import {
  ConfirmEngagementRequest,
  EnrollmentEngagementResponse,
  SelectedEngagementOption
} from './enrollment-engagement-service-types'
import { formatEnrollmentEngagement } from './enrollment-engagement-utils'

const getEnrollmentUrl = () => makeApiUrl('/enrollment/v2/enrollments')

export const createEnrollmentEngagementService = (client = httpServiceClient) => ({
  async fetchEnrollmentEngagement(enrollmentId: string, completedContent?: boolean) {
    const pathUrl = `${getEnrollmentUrl()}/${enrollmentId}/engagement`
    const response = await client<EnrollmentEngagementResponse>({
      method: 'get',
      url: pathUrl,
      ...(completedContent && {
        params: { completedContent: true },
        paramsNamingStrategy: NamingStrategy.snakeCase
      })
    })
    return formatEnrollmentEngagement(response.body.data as EnrollmentEngagementResponse)
  },

  async confirmEngagement(enrollmentId: string, engagementOption: SelectedEngagementOption) {
    const pathUrl = `${getEnrollmentUrl()}/${enrollmentId}/engagement`
    await client<void>({
      method: 'post',
      url: pathUrl,
      body: { source: engagementOption } satisfies ConfirmEngagementRequest
    })
  }
})

export const enrollmentEngagementService = createEnrollmentEngagementService()
